import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { Stack } from '../../layouts/Stack/Stack.js';
import style from './Sidebar.module.css.js';

const Sidebar = ({ children, className, style }) => {
    return (jsx(Stack, { role: "menubar", className: className, direction: "column", style: style, children: children }));
};
const SidebarItem = ({ children, selected, className, onClick }) => {
    return (jsx("div", { role: "menuitem", className: classNames(style.sidebarItem, selected && style.selected, className), onClick: (event) => onClick?.(event), children: children }));
};
Sidebar.Item = SidebarItem;
const SidebarNavItem = ({ children, className, icon, ...props }) => {
    return (jsxs(SidebarItem, { className: classNames(style.sidebarNavItem, className), ...props, children: [icon && jsx("span", { className: style.sidebarNavItemIcon, children: icon }), children] }));
};
Sidebar.NavItem = SidebarNavItem;
const SidebarSpacerItem = ({ children, variant = "both", }) => {
    return (jsx("div", { role: "menuitem", className: classNames(style.sidebarSpacerItem, style[variant]), children: children }));
};
Sidebar.SpacerItem = SidebarSpacerItem;
const SidebarSpace = ({ marginTop, marginBottom }) => {
    return jsx("div", { style: { marginTop, marginBottom } });
};
Sidebar.Space = SidebarSpace;
const SidebarScrollContainer = ({ children }) => {
    return jsx("div", { className: style.scrollContainer, children: children });
};
Sidebar.ScrollContainer = SidebarScrollContainer;
const SidebarHeader = ({ children, className }) => {
    return jsx("header", { className: classNames(style.sidebarHeader, className), children: children });
};
Sidebar.Header = SidebarHeader;
const SidebarDivider = () => {
    return jsx("hr", { className: style.sidebarDivider });
};
Sidebar.Divider = SidebarDivider;

export { Sidebar };
//# sourceMappingURL=Sidebar.js.map
